<template>
  <a-modal
    title="开票信息（须购买人数达到6人或6人以上才可开具发票）"
    :visible="visible"
    :destroyOnClose="true"
    okText="提交"
    cancelText="取消"
    @ok="handleSubmit"
    @cancel="handleCancel">
    <a-spin :spinning="loading">
      <a-form :form="form" class="form" @submit="handleSubmit">
        <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
          <a-input :addon-before="$t('单位名称')" :placeholder="$t('请输入单位名称')" v-decorator="['agencyName', { rules: [{required: true, whitespace:true, message: $t('请输入单位名称')}]}]"/>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
          <a-input :addon-before="$t('纳税人识别号')" :placeholder="$t('请输入纳税人识别号')" v-decorator="['taxpayerNumber', { rules: [{required: true, whitespace:true, message: $t('请输入纳税人识别号')}]}]"/>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
          <a-input :addon-before="$t('联系人员')" :placeholder="$t('联系人员')" v-decorator="['contacts', { rules: [{required: true, message: $t('联系人员')}]}]"/>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
          <a-input :addon-before="$t('联系电话')" :placeholder="$t('请输入联系电话')" v-decorator="['mobile', {rules: [{required: true, message: $t('请输入联系电话')}]}]"/>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
          <a-input :addon-before="$t('邮箱')" :placeholder="$t('请输入邮箱')" v-decorator="['mailbox', {rules: [{required: true, message: $t('请输入邮箱')}]}]"/>
        </a-form-item>
      </a-form>
      
    </a-spin>
  </a-modal>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      visible: false,
      data: null,
      form: this.$form.createForm(this),
      matchId: null,
      agencyId: null
    }
  },
  methods: {
    show (matchId, agencyId) {
      this.visible = true
      this.matchId = matchId
      this.agencyId = agencyId
      this.findData()
    },
    handleCancel () {
      this.visible = false
    },
    findData () {
      this.$api.match.taxpayerMsg({matchId: this.matchId, agencyId: this.agencyId}).then(res => {
        if (res.status === 0) {
          setTimeout(() => {
            this.form.setFieldsValue({
              agencyName: res.data.agencyName,
              taxpayerNumber: res.data.taxpayerNumber,
              contacts: res.data.contacts,
              mobile: res.data.mobile,
              mailbox: res.data.mailbox
            })
          })
        } else {
          setTimeout(() => {
            this.form.setFieldsValue({
              agencyName: '',
              taxpayerNumber: '',
              contacts: '',
              mobile: '',
              mailbox: ''
            })
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          values.matchId = this.matchId
          values.agencyId = this.agencyId
          this.$api.match.taxpayerMsgSave(values).then(res => {
            if (res.status === 0) {
              this.$message.success('成功')
              this.handleCancel()
            } else {
              this.$message.warn(res.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/comm/components/join/pay/InvoiceInformation.vue